import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const getIP = () => {
  return api.get(`${ApiEndpointConstants.GET_IP}`);
};
export const getCountryByIP = () => {
  return api.get(`${ApiEndpointConstants.GET_COUNTRY}`);
};
